import axios from "axios";
const BASE_URL = process.env.REACT_APP_DEV_URL;


export const addProduct = async (token, data) => {
  const url = `${BASE_URL}/products/products-details/`;

  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    if (key === "image" && data[key] instanceof File) {
      formData.append(key, data[key], data[key].name); 
    } else if (data[key] instanceof FileList) {
      Array.from(data[key]).forEach((file) => {
        formData.append(key, file, file.name);
      });
    } else if (key === "product_design_number") {
      const designNumberArray = Array.isArray(data[key]) ? data[key] : [data[key]];
      formData.append(key, JSON.stringify(designNumberArray));
    }  else if (key === "colors") {
      if (Array.isArray(data[key])) {
        formData.append(key, JSON.stringify(data[key])); 
      } else if (data[key] !== null && data[key] !== undefined && data[key] !== "") {
        formData.append(key, data[key]);
      }
    } else if (data[key] !== null && data[key] !== undefined && data[key] !== "") {
      formData.append(key, data[key]);
    }
  });

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.post(url, formData, config);
    return response;
  } catch (error) {
    if (error.response) {
      if (error.response.status >= 400 && error.response.status < 500) {
        console.log("Client Error: Unauthorized Access or Validation Error.", error.response);
        return error.response;
      } else if (error.response.status >= 500) {
        console.error("Server Error.", error.response);
        return error.response;
      }
    } else {
      console.error("Network or unknown error.", error);
      throw error;
    }
  }
};


export const getAllProducts = async (token, params = {}) => {
  const url = `${BASE_URL}/products/products-details/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
    params,
  };

  try {
    const response = await axios.get(url, config);
    console.log("RES==>", response)
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const deleteProduct = async (token, productID) => {
  const url = `${BASE_URL}/products/products-details/${productID}/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.delete(url, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const getProduct = async (token, productID) => {
  const url = `${BASE_URL}/products/products-details/${productID}/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const updateProduct = async (token, data, productID) => {
  const url = `${BASE_URL}/products/products-details/${productID}/`;
  console.log("service", data);

  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    if (key === "image" && data[key] instanceof File) {
      formData.append(key, data[key], data[key].name);
    } else if (Array.isArray(data[key])) {
      // Convert arrays to JSON strings before appending them
      formData.append(key, JSON.stringify(data[key]));
    } else if (data[key] !== null) {
      formData.append(key, data[key]);
    }
  });

  console.log(formData);
  

  const config = {
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const response = await axios.patch(url, formData, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Validation or Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};
